module.exports = __webpack_public_path__ + "img/shop.0e4d602d.webp";